/**
 * The size of the requested thumbnails.
 *
 * @type {Object}
 */
export const THUMBNAIL_SIZE = {
    height: 300,
    width: 300
};
